import {
  BrandAndMarketListItem,
  Int32CriteriaRangeRequest,
  CharCriteriaRequest,
  MarkupPriorityResponse,
  MarkupRequest,
  MarkupTypeResponse,
  CabinCriteriaRequest,
  StringCriteriaRequest,
  CriteriaForBookingDateTimeRequest,
  RuleFormDataAgencyOrGroup,
  PriceBandRequestCriteriaRequest,
  StringIdAndLabel,
  StringCriteriaRangeRequest,
  CriteriaForLocationRequest,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
  FormDataRouteRestriction,
  DateTimeRestrictionData,
  SearchTravelRange,
  CodeAndLabel,
} from '../../../integrated-client';

export interface IMarkupsV2EditorData extends MarkupRequest {}

export interface IMarkupV2Config {
  markupTypes?: Array<MarkupTypeResponse>;
  markupPriorities?: Array<MarkupPriorityResponse>;
}

export interface IEditorData {
  data: MarkupsV2EditorData;
  validation?: any;
  config: IMarkupV2Config;
}

export class MarkupsV2EditorData {
  markupId?: string | undefined;
  brandMarket?: BrandAndMarketListItem;
  accountCodes?: string[] | null | undefined;
  excludeAccountCodes?: boolean | undefined;
  comment?: string | null;
  markupBookingClasses?: Array<CharCriteriaRequest> | null;
  excludeBookingClass?: boolean | undefined;
  bookingDateTimes?: Array<CriteriaForBookingDateTimeRequest> | null;
  bookingPriceBands?: Array<PriceBandRequestCriteriaRequest> | null;
  cabinClasses?: Array<CabinCriteriaRequest> | null;
  excludeCabinClass?: boolean | undefined;
  description?: string | null;
  fareBasisCodes?: string[] | null | undefined;
  fareTypes?: CodeAndLabel[] | null;
  marketingFlightNumbers?: Array<string> | null;
  isDeleted?: boolean;
  isExclusionRule?: boolean;
  includeTax?: boolean;
  salesJourneys?: Array<string> | null;
  locations?: Array<CriteriaForLocationRequest> | null;
  marketingCarriers?: GuidIdCodeAndLabel[] | null | undefined;
  markupAmount?: number;
  markupPercentage?: number;
  passengerAges?: Array<Int32CriteriaRangeRequest> | null;
  relevance?: number;
  markupProviders?: Array<StringIdAndLabel> | null;
  ticketDesignators?: Array<string> | null;
  excludeTicketDesignators?: boolean | undefined;
  markupDistributionChannels?: Array<Int32IdAndLabel> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  travelDates?: Array<SearchTravelRange> | null;
  markupType?: MarkupTypeResponse;
  showDisabled?: boolean;
  basis?: any;
}

export class MarkupV2Config implements IMarkupV2Config {
  markupTypes?: Array<MarkupTypeResponse> | undefined;
  markupPriorities?: MarkupPriorityResponse[] | undefined;

  constructor() {
    this.markupTypes = [];
    this.markupPriorities = [];
  }
}

export class EditorData implements IEditorData {
  data: MarkupsV2EditorData;
  config: IMarkupV2Config;
  validation?: any;

  constructor() {
    this.data = new MarkupsV2EditorData();
    this.data.markupType = { code: 'Static', name: 'Static Markup' };
    this.config = new MarkupV2Config();
  }
}
